<template>
	<div class="reconciliationresult">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div class="contentcard">
						<div style="text-align: center;top: 20%;position: relative;">
							<a-icon type="check-circle" theme="filled" style="font-size: 70px;color: #3ac17e;margin: 0;"/>
							<p style="font-size: 30px;margin-top: 20px;">结算成功</p>
							<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="()=>{this.$router.go(-1);}">返回结算列表</a-button>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				current: ['bdreconciliation'],
				openKeys: ['bdmodule'],
			}
		}

	};
</script>

<style>

	.reconciliationresult .contentcard {
		padding: 24px;
		background-color: #fff;
		height: 100%;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?2ee472ea